import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event as RouterEvent } from '@angular/router';

import { AppLoaderService } from './core/services/app-loader/app-loader.service';
import { AppSessionService } from './core/services/app-session/app-session.service';
import { AuthService } from './core/services/auth/auth.service';
import { Banner } from './core/types/banner';
import { BannerService } from './core/services/banner/banner.service';
import { BodyService } from './core/services/body/body.service';
import { ExceptionService } from './core/services/exception/exception.service';
import { Notification } from './core/types/notifications';
import { NotificationService } from './core/services/notification/notification.service';
import { Session } from './core/models/session';
import { SettingsService } from './core/services/settings/settings.service';
import { SidebarService } from './core/services/sidebar/sidebar.service';
import { SystemUsersService } from './core/services/system-users/system-users.service';
import { ViewerService } from './core/services/viewer/viewer.service';
import { HttpClient } from '@angular/common/http';
import { ApiError } from './core/models/api-error';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(
    private readonly _appLoaderService: AppLoaderService,
    private readonly _appSessionService: AppSessionService,
    private readonly _authService: AuthService,
    private readonly _bannerService: BannerService,
    private readonly _bodyService: BodyService,
    private readonly _exceptionService: ExceptionService,
    private readonly _notificationService: NotificationService,
    private readonly _router: Router,
    private readonly _settingsService: SettingsService,
    private readonly _sidebarService: SidebarService,
    private readonly _systemUsersService: SystemUsersService,
    private readonly _viewerService: ViewerService,
  ) { }

  public get isBlockedBody(): boolean {
    return (this._bodyService.isBlocked || this.isLoading || !this.isCollapsedSidebar);
  }

  public get banner(): Banner {
    return this._bannerService.banner;
  }

  public get exception(): boolean {
    return this._exceptionService.exception;
  }

  public get isClosingLoader(): boolean {
    return this._appLoaderService.isClosing;
  }

  public get isLoading(): boolean {
    return this._appLoaderService.isLoading;
  }

  public get loaderMessage(): string {
    return this._appLoaderService.message;
  }

  public get user(): Session | undefined {
    return this._appSessionService.session;
  }

  public get authorized(): boolean {
    return this._appSessionService.authorized;
  }

  public get notifications(): Notification[] {
    return this._notificationService.notifications;
  }

  public get loadedSettings(): boolean {
    return this._settingsService.loadedSettings;
  }

  public get isOpenViewer(): boolean {
    return this._viewerService.isOpen;
  }

  public get isCollapsedSidebar(): boolean {
    return this._sidebarService.isCollapsed;
  }
}